export const SET_FILTERS = 'SET_FILTERS';
export const SET_FILTERS_FOR_GROUP = 'SET_FILTERS_FOR_GROUP';
export const SET_SAVED_SET_ID = 'SET_SAVED_SET_ID';
export const SET_FILTER_NAME = 'SET_FILTER_NAME';
export const SET_FILTER_ID = 'SET_FILTER_ID';
export const SET_SEARCH = 'SET_SEARCH';
export const RESET_FILTER = 'RESET_FILTER';
export const SET_LAST_SELECTED_TYPE = 'SET_LAST_SELECTED_TYPE';
export const RESET_ALL_FILTERS = 'RESET_ALL_FILTERS';
export const UPDATE_FILTERS_OPTIONS = 'UPDATE_FILTERS_OPTIONS';
